"use client";

import { Circle } from "lucide-react";
import * as React from "react";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { cn } from "~/lib/utils";

type RadioGroupProps = {
  className?: string;
  "data-testid"?: string | undefined;
};

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> &
    RadioGroupProps
>(({ className, "data-testid": dataTestId, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      data-testid={dataTestId || "RadioGroup"}
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

type RadioGroupItem = {
  className?: string;
  "data-testid"?: string | undefined;
};

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> &
    RadioGroupItem
>(({ className, "data-testid": dataTestId, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square h-7 w-7 rounded-full border-[1.5px] border-primary border-radio-border text-accent ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&[data-state=checked]]:border-accent [&[data-state=checked]_svg]:h-[1.125rem] [&[data-state=checked]_svg]:w-[1.125rem]",
        className,
      )}
      data-testid={dataTestId || "RadioGroupItem"}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle
          className="h-2.5 w-2.5 fill-current text-current"
          data-testid={
            dataTestId ? `${dataTestId}-indicator` : "radio-group-Circle"
          }
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
